import { lazyBrowserClient } from './lazylib';

export const sendCustomEvent = data => {
  lazyBrowserClient().then(browserClient => {
    browserClient('sendEvent', data);
  });
};
